<div class="modal-header modal-header-primary">
	<h5 data-testid="SUBSYS2_ATTACHPREVIEW_TITLE_TXT" class="modal-title">
		{{ fileName() || labels().ATTACHMENT_PREVIEW_COMPONENT_TITLE }}
	</h5>
	<button data-testid="SUBSYS2_ATTACHPREVIEW_CLOSE_BTN" type="button" class="btn-close" data-dismiss="modal"
		aria-label="Close" (click)="activeModal.close()" ngbAutoFocus></button>
</div>
<div data-testid="SUBSYS2_ATTACHPREVIEW_IMAGE_BOX" class="modal-body">
	<img [src]="url()" [class]="{ 'flip-hor': isFlipHor(), 'flip-ver': isFlipVer() }" alt="attachment preview" />
</div>